module.exports = __webpack_public_path__ + "static/media/paul.4ad83fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/paul.png
// module id = 304
// module chunks = 0